module.exports = __webpack_public_path__ + "static/media/nodata.65a28d9d.svg";